import './custom-hopian-base.js';

const HOPIAN_TRUST_BAR_SELECTOR = '[id$="__icon_box_pGVH8x"]';

const HOPIAN_TRUST_ITEMS = [
  {
    title: 'FREE U.S. SHIPPING',
    text: 'Free standard shipping on eligible U.S. orders.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true"><path d="M3.5 7h14.5v13.5H3.5V7Z" stroke="#CE1B22" stroke-width="1.8" stroke-linejoin="round"/><path d="M18 11h4.2l4.3 4.5v5H18V11Z" stroke="#CE1B22" stroke-width="1.8" stroke-linejoin="round"/><path d="M18 15.5h8" stroke="#CE1B22" stroke-width="1.8" stroke-linecap="round"/><circle cx="8" cy="22" r="2.2" stroke="#CE1B22" stroke-width="1.8"/><circle cx="22.5" cy="22" r="2.2" stroke="#CE1B22" stroke-width="1.8"/></svg>`
  },
  {
    title: 'SECURE CHECKOUT',
    text: 'Major cards and PayPal accepted.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true"><path d="M15 3.5 24 7v7.2c0 5.4-3.7 9.6-9 12.3-5.3-2.7-9-6.9-9-12.3V7l9-3.5Z" stroke="#CE1B22" stroke-width="1.8" stroke-linejoin="round"/><path d="m10.5 14.7 3 3 6-6" stroke="#CE1B22" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`
  },
  {
    title: '30-DAY RETURNS',
    text: 'Eligible unused items in original condition.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true"><path d="M8 9h14v13H8V9Z" stroke="#CE1B22" stroke-width="1.8" stroke-linejoin="round"/><path d="M8 13h14M15 9v13" stroke="#CE1B22" stroke-width="1.8" stroke-linejoin="round"/><path d="M5.5 10.5V5.5h5" stroke="#CE1B22" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6a10.5 10.5 0 0 1 18.5 6.8" stroke="#CE1B22" stroke-width="1.8" stroke-linecap="round"/></svg>`
  },
  {
    title: 'PRODUCT SUPPORT',
    text: 'Questions about your knife? We’re here to help.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true"><path d="M5 5.5h20v14H13l-6 5v-5H5v-14Z" stroke="#CE1B22" stroke-width="1.8" stroke-linejoin="round"/><path d="M10 11h10M10 15h7" stroke="#CE1B22" stroke-width="1.8" stroke-linecap="round"/></svg>`
  }
];

function updateHopianTrustBar(root = document) {
  const section = root?.matches?.(HOPIAN_TRUST_BAR_SELECTOR)
    ? root
    : root?.querySelector?.(HOPIAN_TRUST_BAR_SELECTOR) || document.querySelector(HOPIAN_TRUST_BAR_SELECTOR);

  if (!section) return;

  const row = section.querySelector('.hdt-row-flex');
  if (!row) return;

  const items = Array.from(row.children).filter((element) => element.classList.contains('hdt-col'));
  if (items.length < HOPIAN_TRUST_ITEMS.length) return;

  HOPIAN_TRUST_ITEMS.forEach((content, index) => {
    const item = items[index];
    const icon = item.querySelector('.hdt-icon_wrap');
    const heading = item.querySelector('.hdt-icons-content .hdt-heading');
    const text = item.querySelector('.hdt-icons-content .hdt-block-text');

    if (icon) icon.innerHTML = content.icon;
    if (heading) heading.innerHTML = `<p>${content.title}</p>`;
    if (text) text.innerHTML = `<p>${content.text}</p>`;
  });
}

updateHopianTrustBar();
document.addEventListener('DOMContentLoaded', () => updateHopianTrustBar(), { once: true });
document.addEventListener('shopify:section:load', (event) => updateHopianTrustBar(event.target));
document.addEventListener('shopify:section:select', (event) => updateHopianTrustBar(event.target));
